import { amplitudeBrowserPlugin } from '@faro/analytics-amplitude2';
import { AnalyticsConfig } from '@faro/study-designer-model';
import Analytics, { AnalyticsInstance } from 'analytics';
import { useEffect, useState } from 'react';

// add to plugins array to enable console log for events
export const debugPlugin = {
    name: 'debug-plugin',
    page: ({ payload }: any): any => {
        console.log('page view fired', payload);
    },
    track: ({ payload }: any): any => {
        console.log('track event payload', payload);
    },
};

export function useAnalyticsInstance(analyticsConfig: AnalyticsConfig | undefined): AnalyticsInstance | null {
    const [analyticsInstance, setAnalyticsInstance] = useState<AnalyticsInstance | null>(null);

    useEffect(() => {
        if (analyticsConfig?.enabled) {
            const amplitude = amplitudeBrowserPlugin({
                apiKey: analyticsConfig.amplitudeapikey,
                fetchRemoteConfig: true,
                autocapture: false,
                cookieOptions: {
                    secure: true,
                    sameSite: 'Strict',
                },
            });

            const analytics = Analytics({
                app: 'Study Designer',
                plugins: [amplitude], // add debugPlugin to the plugins array to enable console log for events
            });

            setAnalyticsInstance(analytics);
        }
    }, [analyticsConfig]);

    return analyticsInstance;
}
